import { render, staticRenderFns } from "./Album.vue?vue&type=template&id=6e81515e&"
import script from "./Album.vue?vue&type=script&lang=ts&"
export * from "./Album.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports